import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import { ISIVChecklistConfirmPage } from 'src/types/SIVChecklist';
import ConfirmPage from './Confirm';
import './SivChecklist.scss';
import {
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  ISIVChecklistStep3Accordions,
  MandatoryData
} from './useSivChecklist';

export interface ISQChecklistPageStep3 {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  setSaveDisable: (saveDisable: boolean) => void;
  expandedState: ISIVChecklistStep3Accordions;
  toggle: (key: keyof ISIVChecklistStep3Accordions, expanded: boolean) => void;
  isUpdate: boolean;
  confirmPageData: ISIVChecklistConfirmPage;
  updateConfirmPage: (data: ISIVChecklistConfirmPage) => void;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  Step3: ISIVChecklistStep3Accordions;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: ISIVChecklistMandatory;
  validateconfirmPage: any;
  validateAllAccordion: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
  notifyUser: any;
  validationObj: any;
  setValidationObj: any;
}

const SQChecklistPage: React.FunctionComponent<ISQChecklistPageStep3> = ({
  getSivChecklistData,
  saveDisable,
  setSaveDisable,
  confirmPageData,
  expandedState,
  isUpdate,
  toggle,
  updateConfirmPage,
  Step3,
  setIsChange,
  updateSIVChecklistMandatoryData,
  mandatory,
  validateconfirmPage,
  validateAllAccordion,
  checkedInStartDate,
  isPublished,
  SignatureBreaking,
  notifyUser,
  validationObj,
  setValidationObj
}) => {
  return (
    <div className="pi-accordion siv-accordion">
      <Accordion
        expanded={expandedState.confirmPage}
        onChange={(_, expanded) => {
          toggle('confirmPage', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography>Confirm </Typography>
        </AccordionSummary>
        <ConfirmPage
          validateAllAccordion={validateAllAccordion}
          getSivChecklistData={getSivChecklistData}
          saveDisable={saveDisable}
          isChange={Step3.confirmPage}
          confirmPageData={confirmPageData}
          isUpdate={isUpdate}
          setIsChange={setIsChange}
          updateConfirmPage={updateConfirmPage}
          updateSIVChecklistMandatoryData={updateSIVChecklistMandatoryData}
          mandatory={mandatory.confirmPage}
          validateconfirmPage={validateconfirmPage}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
          notifyUser={notifyUser}
          validationObj={validationObj}
          setValidationObj={setValidationObj}
        />
      </Accordion>
    </div>
  );
};

export default SQChecklistPage;
